export const phrases = {
  heading_settings_sort: "Сортировка списка сотрудников",
  body_settings_sort: "Сортировка списка сотрудников по имени или фамилии.",
  since_o_clock: "Поскольку часы {time}",
  old_data_warning_my_area: "Мы не смогли загрузить новую информацию. Убедитесь, что вы подключены к Интернету.",
  no_data_warning_my_area: "Убедитесь, что вы подключены к Интернету, и повторите попытку.",
  no_data_available_my_area: "Данные не могут быть загружены",
  last_update_data: "Последнее обновление",
  something_went_wrong_absences: "Что-то пошло не так. Пожалуйста, повторите попытку позже.",
  something_went_wrong_with_the_pin_entry: "Что-то пошло не так с вводом PIN-кода...",
  pin_must_be_four_digits: "PIN-код должен состоять ровно из четырех цифр.",
  pins_do_not_match: "Введенные PIN-коды не совпадают.",
  pin_is_not_numerical: "PIN-код может состоять только из цифр.",
  /** Phrasen für Task.getTechnicalNameFinish
   * -> müssen vermutlich irgendwann nochmal bearbeitet werden
   * z.B. 'Projekt beenden' macht eventuell keinen Sinn, wenn man das Projekt nicht beendet,
   * sondern nur die Arbeitszeit, die man auf dieses Projekt stempelt ?
   */
  finish_work_time: "Штамповать",
  finish_break: "Перерыв в работе",
  finish_loading_time: "Время окончания загрузки",
  finish_driving_time: "Конечное время движения",
  finish_business_trip: "Окончание срока службы",
  finish_project_as_task: "Завершить проект",
  finish_special_one: "End special1",
  finish_special_two: "End Special2",
  you_clockout: "Ты ставишь на себя печать",
  sentence_work_time: "Вы работаете. | Вы работаете прямо сейчас.",
  sentence_break: "Вы делаете перерыв. | Вы делаете перерыв.",
  sentence_loading_time: "В данный момент вы регистрируете время загрузки. Хаурук! | В данный момент вы записываете время загрузки. Придурок!",
  sentence_business_trip: "Сервис вошел в систему. Веселитесь!",
  sentence_driving_time: "Вы бронируете время поездки. Пристегните ремни и вперед! | Вы бронируете время в пути. Пристегните ремни и вперед!",
  sentence_special_one: "Вы бронируете специальный номер 1. | You are booking special 1.",
  sentence_special_two: "Вы бронируете Special 2. | You are booking special 2.",
  sentence_custom_time: "Вы бронируете | Вы бронируете",
  you_are_booked_in_activity: "Вы ставите печать {activity}! | Вы ставите печать {activity}!",
  substitute_warning: "{ days } В случае отсутствия на работе в течение нескольких дней и более должен быть назначен заместитель.",
  substituted_by: "Представлен",
  name_clocked_in: "{name} с печатью",
  /************************************/
  //Signature stuff:

  signature: "Подпись",
  please_sign: "Пожалуйста, подпишитесь",
  signature_with_date: "Подпись на сайте {date}",
  signature_with_date_with_name: "Подпись {date} от {name}",
  signature_with_date_with_location: "Подпись {date} в {location}",
  signature_with_date_with_name_with_location: "Подпись {date} от {name} в {location}",
  signature_with_name: "Подпись {name}",
  signature_with_name_with_location: "Подпись {name} в {location}",
  signature_with_location: "Подпись в {location}",
  /*************************************/

  accept_terms_and_conditions: "Отправляя форму, вы принимаете наши {agb} и {datenschutzerklaerung}.",
  what_is_your_name: "Как тебя зовут?",
  your_email: "Ваш адрес электронной почты",
  what_is_your_company_name: "Как называется ваша компания?",
  what_do_you_want_to_do_with_clockin: "Что вы хотите делать с часиками?",
  almost_finished: "Почти на месте",
  test_clockin_for_amount_period: "Протестируйте clockin {amountOfDaysTestPeriod} бесплатно в течение нескольких дней!",
  code_needed_to_connect: "Используйте свой код",
  you_have_no_company_code: "У вас нет кода? Свяжитесь с сотрудником вашей компании.",
  connect_your_device: "Подключите ваше устройство!",
  please_type_in_device_id: "Введите идентификатор устройства, который вы можете найти в разделе \"Мобильные устройства\" на нашем сайте.",
  new_at_clockin: "Новичок в часовом деле?",
  pin_repeat: "Повторный PIN-код",
  configure_your_pin: "Установите 4-значный PIN-код",
  configure_your_pin_text: "PIN-код необходим для доступа к личному кабинету на планшетном терминале.",
  congratulations: "Поздравляю!",
  start_now: "Начните прямо сейчас",
  device_name_info: "Вы можете изменить имя устройства мобильного устройства, чтобы можно было отслеживать несколько устройств. Пример: \"Смартфон MaxMustermann\". Имя также можно изменить позднее.",
  select_project: "Выберите проект",
  select_time: "Выберите время",
  create_new_account: "Создать новую учетную запись",
  join_my_company: "Присоединяйся к моей компании",
  join_clockin_with_qr: "Регистрация с помощью QR-кода",
  change_project: "Проект изменений",
  my_messages: "Мои новости",
  my_documents: "Мои документы",
  my_data_and_passwords: "Мои данные и пароли",
  my_account_data: "Мои данные",
  change_my_password: "Изменить пароль",
  forgot_password: "Я не знаю своего пароля.",
  open_camera: "Открытая камера",
  scan_now: "Сканировать сейчас",
  sync_now: "Синхронизируйте сейчас",
  clear_logs: "Пустые журналы",
  saveAndGoBack: "Сохранить и вернуть",
  full_day: "Полный день",
  activate_scanner: "Сканер активирован",
  scanner_is_inactive: "Сканер неактивен",
  change_project_by_scan_qr: "Отсканируйте QR-код проекта, на который вы хотите перейти.",
  scan_device_by_qr: "Отсканируйте QR-код с устройства, которое вы хотите использовать.",
  no_access_to_camera_please_connect_device_manually: "К сожалению, доступ к камере не удалось получить, пожалуйста, введите код устройства вручную.",
  no_access_to_camera_please_clockin_manually: "К сожалению, доступ к камере был невозможен, пожалуйста, поставьте штамп вручную.",
  qr_code_login: "Регистрация QR-кода",
  scan_to_login: "Отсканируйте свой QR-код, чтобы войти в систему.",
  checklist_was_saved: "Контрольный список сохранен",
  question_save_changes_short: "Сохранить изменения?",
  question_save_changes: "Хотите ли вы сохранить изменения?",
  question_delete_checklist_short: "Удалить контрольный список?",
  question_delete_checklist: "Вы уверены, что хотите удалить контрольный список?",
  checklist_is_sending: "Чек-лист будет отправлен",
  checklist_sent_successfully: "Чек-лист успешно 🎉 отправлен",
  checklist_could_not_be_sent: "Чек-лист не удалось отправить, повторите попытку позже.",
  checklist_transmission_problems_in_the_past: "В прошлом возникали проблемы с передачей некоторых файлов.",
  checklist_send_with_potential_data_loss: "Хотели бы вы попробовать отправить чек-лист без этих файлов?",
  documentation_is_sending: "Отправляется проектная документация",
  documentation_sent_successfully: "Проектная документация успешно отправлена 🎉",
  confirm_documentation_dismissal: "Вы действительно хотите выбросить документацию?",
  discard_unsaved_changes: "Хотите отказаться от изменений?",
  documentation_will_be_sent_when_online: "Документы будут отправлены, как только вы снова окажетесь в сети.",
  confirmation_is_sending: "Отправляется подтверждение проекта",
  ask_for_geo_permission: "Этому приложению необходимо ваше местоположение, " + "но не имеет на это разрешения.\n\n" + "Хотите ли вы открыть настройки?",
  all_projects: "Все проекты",
  half_day: "Полдня",
  start_end: "По времени",
  my_area: "Моя область",
  my_area_video_teaser_clockin_explained_by_frederik: "Clockin объяснение Фредди",
  add_time: "Создать время",
  show_times_in_confirmation: "Время показа в подтверждении",
  change_time: "Время изменения",
  finish_project: "Завершить проект",
  finish_project_date: "Окончательное назначение",
  unfinish_project: "Открыть проект заново",
  unfinish_project_date: "Повторное назначение",
  absence_overview: "Управление отсутствием на рабочем месте",
  edit_absence: "Отсутствие редактирования",
  edited_absence: "Отсутствие отредактировано",
  created_absence: "Заявление на отпуск успешно создано",
  creating_absence: "Теперь ваше заявление на отпуск создано",
  error_creating_absence: "Ошибка при создании запроса на отсутствие",
  create_absence: "Создать отсутствие",
  deleted_absence: "Заявление об отзыве отсутствия",
  new_request: "Новое приложение",
  your_requests: "Ваши приложения",
  planned_days: "Плановые дни",
  planned_hours: "Запланированные часы работы",
  used_days: "Использованные дни",
  used_hours: "Затраченных часов",
  free_days: "выходные дни",
  free_hours: "Часы работы в отпуске",
  open_days: "Дни открытых дверей",
  open_hours: "Часы работы",
  withdraw_request: "Отозвать заявление",
  change_request: "Запрос на изменение",
  request_was_approved: "Ваше заявление было одобрено",
  request_is_pending: "Ваше заявление еще не было одобрено",
  request_was_rejected: "Ваше заявление было отклонено",
  add_attachment: "Добавить вложение",
  message_optional: "Сообщение (необязательно)",
  filed_on: "Представлено на",
  this_year: "В этом году",
  search_sub_projects: "Над каким подпроектом вы хотели бы работать?",
  error_occurred: "Произошла ошибка, повторите попытку позже.",
  re_record: "Удалить и перезаписать это видео?",
  delete_video: "Удалить запись?",
  no_results_found: "Результаты не найдены",
  record_again: "Снова пробовать",
  request_valid_email: "Пожалуйста, введите действительный адрес электронной почты.",
  request_valid_company_name: "Пожалуйста, введите действительное название компании.",
  request_valid_first_name: "Пожалуйста, введите действительное имя.",
  request_valid_last_name: "Пожалуйста, введите правильную фамилию.",
  total_duration_today: "Общее время сегодня",
  show_daily_protocol: "Показать ежедневный журнал",
  change_profile_pic: "Изменить изображение профиля",
  logout_account: "Отключить счет",
  you_are_working: "Вы работаете прямо сейчас!",
  you_are_taking_a_break: "У вас перерыв!",
  activity_edited: "Деятельность отредактирована",
  activity_edited_undo: "Обработка успешно отменена",
  activity_edited_missing_project: "О, проект все еще отсутствует!",
  activity_deleted: "Активность удалена",
  activity_deleted_undo: "Восстановление удаленных действий",
  activity_created: "Создан новый вид деятельности",
  activity_created_undo: "Вновь созданная деятельность выведена",
  correct_working_hours: "Правильное рабочее время",
  your_changes_are_being_saved: "Теперь ваши изменения сохранены.",
  manage_working_hours: "Управление рабочим временем",
  delete_activity: "Удалить деятельность",
  start_navigation: "Начать навигацию",
  no_valid_email: "Введенный адрес электронной почты недействителен.",
  delete_checklist: "Удалить контрольный список",
  active_checklists: "Активные контрольные списки",
  scan_qr_code: "Сканирование QR-кода",
  switch_to_office_center: "Переход в офисный центр",
  confirm_project_completion_short: "Завершить проект",
  confirm_project_date_completion_short: "Окончательное назначение",
  project_completed: "Проект завершен!",
  project_date_completed: "Назначение завершено!",
  confirm_project_uncompletion_short: "Открыть проект заново",
  confirm_project_date_uncompletion_short: "Повторное назначение",
  project_uncompleted: "Проект активирован",
  project_date_uncompleted: "Дата активации",
  choose_project: "Выберите проект",
  choose_sub_project: "Выберите подпроект",
  choose_site: "Выберите местоположение",
  active_projects: "Активные проекты",
  completed_term: "заполнено",
  completed_projects: "Завершенные проекты",
  end_of_work: "Приятного вечера",
  correct_time: "Правильное время",
  you_stamp_x: "Вы штампуете",
  enter_pin: "Пожалуйста, введите PIN-код",
  wrong_pin: "Неправильный ввод PIN-кода",
  pin_change_required: "Вам было предложено изменить PIN-код.",
  enter_new_pin: "Введите новый PIN-код",
  approve_pin: "Подтверждение PIN-кода",
  no_projects_scheduled: "Для {day} Проекты не сохраняются.",
  you_clock_in_project: "С этого момента вы записываете рабочее время проекта.",
  project_scan_error: "Этот код не действителен ни для одного проекта.",
  show_more_days: "показать больше дней",
  show_more_times: "Показать больше раз",
  only_show_today: "Показать только сегодня",
  todays_total_time: "Общее время сегодня",
  everything_synced: "Ваши данные актуальны!",
  upload_in_progress: "Данные загружаются...",
  who_are_you: "Ты кто?",
  is_uploading_to_server: "Ваши изменения передаются в офисный центр.",
  offline_and_data_is_stored_locally: "Вскоре ваши изменения будут переданы в офисный центр. ",
  show_more: "показать больше",
  activity_edited_wrong_date: "Вы ввели неправильную дату.",
  confirm_logout: "Вы действительно хотите отказаться от подписки?",
  confirm_clockout: "Вы уверены, что хотите отработать сегодня?",
  gps_is_active: "Передача данных GPS",
  location_tracking_is_active: "Чтобы включить GPS-слежение.",
  app_settings: "Настройки приложения",
  clock_reminder: "Штамп — напоминание",
  mon_to_fri: "Стандарт: с понедельника по пятницу",
  logout: "Отключить счет",
  refresh: "Обновление",
  prompt_language_settings: "Установите язык приложения здесь.",
  prompt_clock_reminder: "Напоминание через push-уведомления для соответствия вашей повседневной работе.",
  register_company: "Зарегистрировать компанию",
  use_code: "Используйте код",
  our_customers: "Наши клиенты",
  free_test_now: "Тест теперь бесплатный",
  tier_attendance: "Я фиксирую только рабочие часы и перерывы.",
  tier_documentation: "Я также хочу забронировать рабочие часы по проектам, которыми я управляю в clockin.",
  your_tier: "Ваш пакет",
  all_clockin_functions: "Все функции синхронизации",
  checklists_formulars: "Контрольные списки и функции",
  projectfile_incl_chat: "Цифровые файлы проекта (включая чат)",
  photo_sketch_note: "Функция фото, эскизов и заметок",
  digital_signature: "Цифровые подписи",
  datev_connection: "соединение DATEV",
  calendar_absences: "Управление календарем и отсутствием",
  individual_design: "Индивидуальный взгляд",
  attendance_time_tracking: "Стационарный учет рабочего времени через планшетный терминал",
  mobile_time_tracking: "Мобильный учет рабочего времени через приложение для смартфона",
  browser_time_tracking: "Запись времени работы браузера на ПК для домашнего офиса",
  help_use_code: "Пожалуйста, введите код, который вы найдете в офисном центре в разделе \"Мобильные устройства/сотрудники\".",
  wrong_code: "Неправильный код",
  wrong_code_text: "Код недействителен. Пожалуйста, повторите попытку с действительным кодом",
  wrong_code_text_short: "Код недействителен",
  clockin_logo: "Логотип Clockin",
  invalid_qr_code: "Неверный QR-код",
  invalid_qr_code_text: "Отсканированный QR-код недействителен. Пожалуйста, отсканируйте действительный код clockin.",
  code_already_connected: "С помощью этого кода вы можете подключить свое устройство. Но вы уже подключены.",
  wrong_credentials: "Некорректные данные доступа",
  wrong_credentials_text: "Введенная вами комбинация e-mail и пароля не найдена. Пожалуйста, проверьте введенные вами данные и повторите попытку.",
  new_pin: "Введите новый PIN-код",
  choose_next_action: "Выберите следующее действие",
  name_of_software_package: "Название пакета программного обеспечения",
  select_teamleader: "Кто ставит печати для команды?",
  select_teamleader_description: "Для продолжения работ по изготовлению штампов выберите человека, который теперь будет управлять машиной.",
  clocked_in_on_this_device: "Штамповка на данном устройстве",
  not_clocked_in_on_this_device: "На данном устройстве не штампуется",
  select_new_teamleader: "Кто теперь должен штамповать команды?",
  switch_teamleader: "Передача устройства",
  just_me: "Просто отбой",
  select_the_new_teamleader: "Определите нового руководителя группы",
  back_to_selection: "вернуться к выбору",
  manage_team: "Управление командой",
  total_time_team: "Общее время работы команды",
  count_members_clocked_in: "{clockedin}/{members} Члены команды с печатью в",
  whole_team: "Вся команда",
  teammembers_still_clockedin: "Выбирайте, хотите ли вы вести учет рабочего времени только для себя или для всех членов команды?",
  clockout_all: "Вычеркнуть все",
  select_employee: "Сначала выберите пользователя",
  something_went_wrong: "Что-то пошло не так, пожалуйста, повторите попытку позже.",
  new_pin_successfully_changed: "PIN-код успешно изменен",
  enter_pin_before_clockin_prompt: "Сначала введите свой PIN-код по очереди, чтобы войти в систему.",
  enter_pin_before_clockout_prompt: "Сначала введите свой PIN-код один раз, чтобы выйти из часов.",
  delete_activity_alert_title: "Удалить деятельность",
  delete_activity_alert_msg: "Вы уверены, что хотите удалить активность?",
  delete_absence_message: "Вы уверены, что хотите отозвать заявление?",
  delete_absence_title: "Отозвать заявление",
  are_you_sure: "Вы уверены?",
  request_password: "Запрос нового пароля",
  password_requested: "Ссылка для нового пароля была отправлена на ваш адрес электронной почты.",
  no_email_retrieved: "Не получили письмо? Пожалуйста, проверьте папку \"Спам\" или попробуйте еще раз.",
  name_of_customer: "Имя клиента",
  missing_permissions_homepage_text: "У вас нет разрешения на изменение активности на этой машине. Обратитесь к администратору для получения доступа.",
  no_permission_warning_my_area: "У вас нет разрешения на доступ к этой области. Обратитесь к администратору, чтобы получить доступ.",
  employee_clocked_in: "{name} зарегистрирован!",
  employee_clocked_out: "{name} вышел из системы!",
  no_employee_to_qr_code_warning: "Для этого QR-кода не удалось найти сотрудника.",
  no_employees_registered_heading: "В это подразделение пока не назначены сотрудники.",
  no_employees_registered_body: "В офисном центре в настройках мобильного устройства можно назначить сотрудников, которым затем будет разрешено записывать свое время на этом устройстве.",
  no_employee_found: "К сожалению, никого с таким именем найти не удалось.",
  no_employee_assigned: "Сотрудник не назначен",
  you_need_help: "Вам нужна помощь?",
  here_you_can_get_help_to_register_employees_for_device: "Здесь вы найдете всю информацию о том, как назначить сотрудников в подразделение.",
  show_time: "Создать время",
  export_timesheet: "Экспорт табеля учета рабочего времени",
  select_month: "Выберите месяц",
  internet_connection_required: "Для этого необходимо подключение к Интернету.",
  select_an_activity_to_clockin_your_team: "Выберите вид деятельности, чтобы поставить штамп в своей команде.",
  confirm_uploading_sqlite_for_debugging: "Вы уверены, что хотите загрузить данные в приложение для поддержки Clockin?",
  no_tasks_available: "Нет задач",
  click_to_add_tasks: "Нажмите, чтобы добавить задачи",
  scan_nfc_tag: "Поднесите карту к считывающему устройству.",
  link_nfc_tag: "Привязка NFC-метки",
  select_employee_for_nfc_tag: "Пожалуйста, выберите сотрудника, чтобы привязать эту NFC-метку:",
  nfc_tag_linked_successfully: "Метка NFC успешно работает с {name} Связан.",
  nfc_linking_failed: "Не удалось связать NFC-метку. Пожалуйста, повторите попытку.",
  nfc_not_enabled: "NFC не поддерживается этим устройством или отключен.",
  nfc_initialization_failed: "К сожалению, что-то пошло не так. Пожалуйста, повторите попытку.",
  nfc_scan_failed: "К сожалению, что-то пошло не так. Пожалуйста, повторите попытку.",
  nfc_no_tag_found: "NFC-метка не была найдена.",
  nfc_tag_already_linked_to: "Эта метка NFC уже доступна с {name} Связан.",
  nfc_scan_active: "Сканирование NFC активно",
  nfc_linking_enabled: "Метки NFC теперь можно связывать. Пожалуйста, удерживайте метку NFC, чтобы быть связанной со считывателем NFC.",
  nfc_all_employees_linked: "Все сотрудники, назначенные на это устройство, уже привязаны.",
  no_employee_to_nfc_warning: "Для этой метки NFC не удалось найти ни одного сотрудника.",
  select_employee_to_link_nfc: "К кому следует привязать NFC-метку?",
  new_onboarding: {
    personal_app_manager: {
      heading: {
        welcome: "Добро пожаловать в Clockin",
        clocking_time: "Время на трассе",
        push_notifications: "Ничего не забывай"
      },
      text: {
        clocking_time: "Clocker — это отправная точка для любого действия. Ты занимаешься своей работой, приложение занимается документацией.",
        push_notifications: "Теперь включите уведомления. Clockin напоминает вам, если вы забыли штамп, и следит за тем, чтобы получить всё важное сразу."
      },
      button: {
        lets_go: "Приступить к работе прямо сейчас"
      }
    },
    my_area: {
      heading: {
        my_area: "Моя область",
        absences: "Отсутствия и заявления",
        settings: "Персональные настройки"
      },
      text: {
        my_area: "Центральное место, где вы можете получить мгновенный обзор своего рабочего времени и сверхурочных. Отсюда вы можете управлять своим рабочим временем, получать доступ к ежедневному журналу, подавать запросы и просматривать свое время.",
        absences: "Управление заявками на отпуск, больничные и другие дни отсутствия. Всегда следите за состоянием своих заявок и быстро и легко подавайте новые заявки всего несколькими щелчками мыши.",
        settings: "Отправить сообщения в компанию или изменить свои персональные настройки, а если Вы хотите изменить пароль, то это можно сделать здесь же!"
      },
      button: {
        lets_go: "Начните"
      }
    }
  },
  onboarding: {
    personal_app: {
      heading: {
        your_time_matters: "Потому что ваше время имеет значение",
        clock_in: "Штамп в",
        switch_task: "Замена штампа",
        clock_out: "Штамповать",
        thats_it: "Вот и все!"
      },
      text: {
        your_time_matters: "С помощью функции clockin мы помогаем вам сосредоточиться на главном. Учет рабочего времени осуществляется одним щелчком мыши.",
        clock_in: "Одним щелчком мыши вы сразу попадаете в часы. Clockin автоматически сохраняет данные, и вы всегда будете иметь их в поле зрения.",
        switch_task: "Занимаетесь другим проектом, делаете перерыв или отправляетесь на следующую встречу? Просто перепишите себя на новый вид деятельности. Остальное записывается автоматически.",
        clock_out: "И одним щелчком мыши вы получаете печать.",
        thats_it: "Вы сделали это и готовы к учету рабочего времени. Если вам нужна помощь, просто свяжитесь с нами. С системой clockin все просто - в том числе и общение с нами."
      },
      button: {
        your_time_matters: "Покажите мне, как это делается",
        thats_it: "Приступить к работе прямо сейчас"
      }
    },
    team_app: {
      heading: {
        your_time_matters: "Потому что ваше время имеет значение",
        clock_in: "Штамп в",
        clock_in_team: "Команда регистрации",
        switch_task: "Замена штампа",
        change_teamleader: "Передача устройства",
        clock_out: "Штамповать",
        thats_it: "Вот и все!"
      },
      text: {
        your_time_matters: "С помощью системы clockin мы помогаем вам сосредоточиться на главном. Учет рабочего времени сотрудников осуществляется одним щелчком мыши.",
        clock_in: "Выберите сотрудника, который ведет учет рабочего времени в команде, и одним щелчком мыши введите его в систему. clockin автоматически сохраняет данные, и вы можете постоянно следить за всем происходящим.",
        clock_in_team: "Просто поставьте прямую печать на свою команду. Как всем одновременно, так и отдельным членам.",
        switch_task: "У вас есть другой проект, вы делаете перерыв или едете на следующую встречу? Просто поставьте штамп о новом занятии. Остальное будет записано автоматически.",
        change_teamleader: "Вы заканчиваете работу, вынуждены уехать или больше не задерживаетесь в коллективе? Просто передайте устройство в приложение, и все вернется на круги своя.",
        clock_out: "И одним щелчком мыши вы и ваша команда отключаетесь от работы. Разумеется, в любой момент можно вывести из работы и отдельных сотрудников.",
        thats_it: "Вы сделали это и готовы вести учет рабочего времени для своей команды. Если вам нужна помощь, просто свяжитесь с нами. С системой clockin все просто - в том числе и общение с нами."
      },
      button: {
        your_time_matters: "Покажите мне, как это делается",
        thats_it: "Приступить к работе прямо сейчас"
      }
    },
    my_area: {
      heading: {
        welcome: "Добро пожаловать в ваш регион",
        my_area: "Моя область",
        create_time: "Создать время",
        change_time: "Правильное время",
        absences: "Отсутствия и заявления",
        settings: "Персональные настройки",
        thats_it: "Вот и все!"
      },
      text: {
        welcome: "Откройте для себя еще больше способов эффективного и простого управления рабочим временем. Давайте посмотрим на вашу область.",
        my_area: "Центральное место, где вы можете получить мгновенный обзор своего рабочего времени и сверхурочных. Отсюда вы можете управлять своим рабочим временем, получать доступ к ежедневному журналу, подавать запросы и просматривать свое время.",
        create_time: "Вы забыли ввести время или хотите добавить его позже? Нет проблем! Добавляйте пропущенное время, фиксируйте перерывы и поддерживайте учет рабочего времени в актуальном состоянии.",
        change_time: "Хотите скорректировать время? Нет проблем! С помощью функции clockin вы можете легко исправить и скорректировать неправильное время.",
        absences: "Управление заявками на отпуск, больничные и другие дни отсутствия. Всегда следите за состоянием своих заявок и быстро и легко подавайте новые заявки всего несколькими щелчками мыши.",
        settings: "Отправить сообщения в компанию или изменить свои персональные настройки, а если Вы хотите изменить пароль, то это можно сделать здесь же!",
        thats_it: "Вы сделали это! Теперь Вы можете без труда управлять своим временем, организовывать пропуски и концентрироваться на главном - работе. Удачи вам и продуктивного времяпрепровождения!"
      },
      button: {
        welcome: "Покажите мне, как это делается",
        thats_it: "Приступить к работе прямо сейчас"
      }
    },
    clock: {
      clockin_now: "Заблокировать сейчас",
      clock_your_first_time_now: "& запись в первый раз"
    }
  },
  surveys: {
    nps: {
      thanks_for_using_clockin: "Спасибо за использование часового механизма!",
      question: "Насколько вероятно, что вы порекомендуете компанию clockin друзьям или коллегам?",
      very_likely: "Очень вероятно",
      very_unlikely: "Очень маловероятно",
      help_us_improve: "Как мы можем улучшить часовой механизм для вас?",
      what_do_you_agree_with: "С какими утверждениями вы бы согласились?",
      choose_three_statements: "Выберите не более трех утверждений.",
      hard_to_use: "Сложность в эксплуатации",
      lacking_features: "Слишком мало функций",
      does_not_help_me: "не облегчает мой рабочий день",
      confusing: "путаница",
      poorly_implemented: "Функции реализованы плохо",
      too_buggy: "слишком подвержен ошибкам",
      too_slow: "длительное время загрузки",
      what_else: "Есть ли что-нибудь еще, что вы хотели бы нам рассказать?",
      can_we_ask_you_a_few_questions: "Мы можем задать вам еще несколько вопросов?",
      how_happy_are_you_with_the_introduction_of_clockin: "Насколько вы довольны введением в вашей компании часофикации?",
      how_much_do_you_enjoy_using_clockin: "Как вам нравится пользоваться часами?",
      how_much_easier_does_clockin_make_your_work: "Насколько часовой пояс облегчает вашу повседневную работу?",
      how_happy_are_you_with_the_following_aspects: "Насколько вы удовлетворены следующими пунктами?",
      clarity_of_the_app: "Понятность приложения",
      simplicity_of_use: "Простота эксплуатации",
      app_features: "Функции в приложении",
      feedback_received: "Ваш отзыв получен. Спасибо, что нашли время.",
      thanks_for_taking_the_time: "Спасибо, что нашли время.",
      what_can_we_do_to_improve: "Не могли бы вы рассказать нам о своем опыте, чтобы в следующий раз мы смогли сделать все еще лучше?",
      what_can_we_do_to_get_it_right: "Не могли бы вы рассказать нам о своем опыте, чтобы в следующий раз мы могли сделать все правильно?",
      comment_placeholder: "Ваше сообщение"
    }
  },
  travel_logs: {
    add: "Добавьте информацию о поездке",
    edit: "Редактирование деталей поездки",
    saving: "Детали путешествия сохраняются...",
    saved_successfully: "Информация о путешествии успешно сохранена!",
    unable_to_save: "К сожалению, ничего не вышло 😢."
  },
  attach_file: "Прикрепить файл",
  image_to_text: {
    info: "Убедитесь, что текст хорошо различим и полностью виден на изображении.",
    attach_image: "Прикрепите фотографию",
    processing: "Ваш текст будет прочитан.",
    processing_failed: "К сожалению, импорт не сработал 😢.",
    no_text_found: "Не удалось распознать ни одного текста."
  },
  correction_enter_reason: "Пожалуйста, укажите причину исправления.",
  daily_notes: {
    add: "Напишите заметку",
    edit: "Примечание",
    saving: "Заметка сохранена...",
    saved_successfully: "Заметка успешно сохранена!",
    unable_to_save: "К сожалению, ничего не вышло 😢.",
    no_notes_yet: "Записка не создана",
    create_note: "Создать"
  },
  calendar_sync: {
    title: "Синхронизация расписания",
    description: "Синхронизируйте свой рабочий график с календарем и следите за старыми и новыми встречами.",
    url: "Адрес в формате iCal",
    url_description: "Вы можете использовать этот адрес для доступа к календарю из других приложений.",
    note: "Примечание",
    note_description: "В некоторых календарях отображение новых встреч может занимать до 24 часов.",
    sync_now: "Синхронизация календаря",
    copied: "url календаря скопирован."
  },
  registration: {
    skip_all: "Пропустить все",
    already_signed_up: "У меня уже есть аккаунт",
    title_1: "Давайте начнем! Какое время вы хотели бы записать с помощью clockin?",
    description_1: "Мы разработаем для вас индивидуальные часы",
    option_1_a: "Общее рабочее время (приход, уход и перерыв)",
    option_1_b: "Время работы над проектом",
    title_2: "Вы хотите задокументировать?",
    description_2: "Какие требования должны быть выполнены для этого?",
    option_2_a: "Фотографии",
    option_2_b: "Наброски",
    option_2_c: "Функция примечания",
    option_2_d: "Контрольные списки и формы",
    option_2_e: "Цифровые файлы проекта",
    title_3: "Что еще вы хотели бы оцифровать?",
    description_3: "На сайте clockin есть много интересного, возможно, вы найдете что-то для себя.",
    option_3_a: "Праздник",
    option_3_b: "Болезни и прогулы",
    option_3_c: "Цифровое личное дело",
    option_3_d: "Анализ компании",
    option_3_e: "Планирование развертывания",
    option_3_f: "Налоговый консультант по передаче данных (DATEV)",
    title_4: "В какой отрасли работает ваша компания?",
    description_4: "Мы хотим узнать вас получше, чтобы мы могли подобрать часы в соответствии с вашими потребностями.",
    option_4_a: "услуги",
    option_4_b: "Ремесло",
    option_4_c: "Здоровье и благополучие",
    option_4_d: "Закупки, заказы и торговля",
    option_4_e: "Гостиница и общественное питание",
    option_4_f: "Автомобили, транспорт и оборудование",
    option_4_g: "Другая промышленность",
    title_5: "Сколько сотрудников работает в вашей компании?",
    description_5: "Учитывая количество сотрудников, мы можем подобрать часы в соответствии с размером вашей компании.",
    title_6: "Супер! Ваши часы теперь настроены",
    description_6: "Все, что нам нужно, - это ваше имя.",
    input_6_a: "Компания",
    input_6_b: "Имя",
    input_6_c: "Фамилия",
    input_6_d: "Номер телефона",
    title_7: "Вы готовы к работе! Попробуйте часовой механизм в течение 14 дней бесплатно!",
    input_7_a: "Ваш адрес электронной почты",
    description_7: "На какой адрес электронной почты следует отправить пароль?",
    input_7_b: "Так мне стало известно.",
    how_did_you_hear_about_clockin: "Как вы впервые узнали о компании clockin?",
    recommendation_option_1: "Рекомендация",
    recommendation_option_2: 'Facebook',
    recommendation_option_3: 'Instagram',
    recommendation_option_4: "Поиск в Интернете",
    recommendation_option_5: 'LinkedIn',
    recommendation_option_6: "Сравнительная платформа",
    recommendation_option_7: "Статьи в журналах и Интернете",
    known_from: "Известно из",
    agb_1: "Отправляя форму, вы принимаете ",
    agb_2: 'AGB',
    agb_3: " и ",
    agb_4: "Политика конфиденциальности",
    start: "Стартовый тест",
    validation_failed: "Пожалуйста, заполните все поля правильно."
  },
  clocki: {
    listening_heading: "Я слушаю вас",
    listening_subtext: "Чем я могу вам помочь?",
    hi_0: "Здравствуйте, чем я могу вам помочь?",
    hi_1: "Привет, чем могу помочь?",
    hi_2: "Здравствуйте, чем я могу вам помочь?",
    hi_3: "Moin moin, чем я могу вам помочь?",
    hi_4: "Здравствуйте, чем я могу вам помочь?",
    hi_5: "Здравствуйте, чем я могу вам помочь?",
    // hi_1: 'Hi {name}​, sag mir, wie kann ich dir helfen?',
    // hi_2: 'Hi {name}​, wie kann ich dir helfen?',
    // hi_3: 'Hi {name}​, was kann ich für dich tun?',
    // hi_4: 'Moin {name}​, was kann ich für dich tun?',
    // hi_5: 'Hallo {name}​, wie kann ich dir helfen?',
    // hi_6: 'Grüß dich {name}​, wobei kann ich dich unterstützen?',
    // hi_7: 'Guten Tag {name}​, womit kann ich dir heute helfen?',
    speech_recognition_unavailable: "К сожалению, распознавание голоса, похоже, не работает на вашем устройстве",
    microphone_permission_denied: "К сожалению, у меня нет доступа к вашему микрофону. Пожалуйста, проверьте разрешения в настройках, чтобы я мог вас слышать.",
    please_speak: "Теперь вы можете поговорить с Клокки",
    create_activity: "Создание мероприятия",
    modify_activity: "Изменение активности",
    delete_activity: "Удаление действия",
    create_daily_note: "Создание ежедневной заметки",
    search_project: "Поиск проекта",
    note_copied: "Примечание скопировано",
    create_absence_request: "Отсутствие запроса",
    delete_absence: "Удалить отсутствие",
    confirm_deletion: "Вы уверены, что ваш {activity_label} Штамповка от {date} Часы должны быть удалены?",
    confirm_absence_deletion: "Вы уверены, что ваш запрос на {category} из {startDate} до {endDate} Хотите удалить?",
    task_before_modification: "Перед: {task}",
    starts_at_before_modification: "Время начала до: {startsAt}",
    ends_at_before_modification: "Время окончания до: {endsAt}",
    something_went_wrong: "Что-то пошло не так, пожалуйста, повторите попытку позже.",
    was_this_helpful: "Может ли Clocki вам помочь?",
    actions: {
      CREATE_ABSENCE: {
        title: "Подтвердите отсутствие"
      },
      CREATE_DAILY_NOTE: {
        title: "Создайте заметку прямо сейчас",
        daily_notes_disabled: "К сожалению, функция заметок отключена. Пожалуйста, попросите вашего администратора активировать эту функцию в офисном центре.",
        success: "Заметка успешно сохранена в ежедневнике 🎉"
      },
      CREATE_PROJECT_NOTE: {
        title: "Создайте документацию прямо сейчас",
        created_by_clocki: "Создано с помощью Clocki"
      },
      REDIRECT_TO_CORRECT_TIMES: {
        title: "Откройте \"Мои времена\" прямо сейчас"
      },
      REDIRECT_TO_MY_AREA: {
        title: "Откройте \"Мой район\"."
      },
      REDIRECT_TO_CHANGE_PASSWORD: {
        title: "Откройте \"Изменить пароль\"."
      },
      CHANGE_ACTIVITY: {
        WORKING_TIME: "Теперь штамп \"рабочее время\"",
        PAUSE: "Нажмите кнопку \"Пауза\".",
        DRIVING_TIME: "Ставьте штамп \"Время в пути\" прямо сейчас",
        LOGOUT: "Разблокировать сейчас"
      }
    }
  },
  review_prompt: {
    do_you_like_clockin: "Вам нравится использовать Clockin?"
  },
  translation_failed: "К сожалению, перевод не получился 😕",
  video_transcript_not_available: "Расшифровка отсутствует",
  video_upload_succeeded: "Загрузка видео завершена.",
  video_upload_failed: "Загрузка видео не удалась.",
  video_send_failed: "Видео на данный момент не удалось транслировать. Попробуем позже.",
  uploading_video: "Загружаю видео...",
  language_selection_header: "Выбрать язык",
  language_selection_message: "Выбирайте предпочитаемый язык",
  shifts: {
    my_shifts: "Мои смены",
    free_shifts: "Свободные смены",
    next_shift: "Твоя следующая смена",
    shift_not_found: "Слоёв не найдено",
    show_shift_plan: "Посмотреть этот график смены",
    no_shift_place: "Местоположение не указано",
    no_shifts_assigned: "В данный момент вы не назначены ни на одну смену",
    free_shifts_unavailable: "В настоящее время бесплатные смены недоступны",
    filter_shift_plans: "Графики сдвига фильтра",
    no_shift_plans_available: "Графиков смены недоступны",
    filter_locations: "Места фильтрации",
    no_locations_available: "Свободных мест нет",
    no_plan_selected: "Расписание смены не выбрано",
    no_shifts_for_plan: "Для этого плана слоёв не найдено",
    no_shifts_for_location: "Сдвигов для выбранного места не обнаружено",
    unknown_shift_plan: "Неизвестное расписание смены",
    unknown_location: "Местоположение неизвестно",
    loading_more_shifts: "Загрузите ещё слои..."
  },
  clockin_reminder_title: "Уже на работе? 🔔",
  clockin_reminder: "Не забудьте отметить приём.",
  clockout_reminder_title: "Ты уже на конце? 🔔",
  clockout_reminder: "Не забудьте уходить с работы.",
  choose_clockin_reminder_time: "Время напоминания о прихождении.",
  choose_clockout_reminder_time: "Время напоминания о выходе рабочего времени",
  choose_break_reminder_time: "Длительность паузы",
  saved_successfully: "Успешно сохранено 👍",
  clock_reminder_channel_name: "Напоминания о штампах",
  clock_reminder_channel_description: "Напоминания о прибытии и завершении",
  break_reminder_title: "Ты всё ещё делаешь перерыв? ⏰",
  break_reminder: "Примечание: ваше время перерыва всё ещё идёт.",
  // Video component translations
  video_not_supported: "Ваше устройство не поддерживает видео :/",
  video_loading_error: "Загрузка видео при ошибке",
  video_retry: "Перезарядка"
};